import { memo } from 'react';
import { Grid, Stack, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { IndexListItemButton } from 'components/styles_components/list';
import { InspectionResultLink } from 'utils/link';
import { userLabel } from 'utils/user';
import Date from 'components/date';
import Result from 'components/inspection/result';
import useMobile from 'hooks/use_mobile';

const ListItem = ({ inspectionResult }) => {
  const navigate = useNavigate();
  const isMobile = useMobile();

  const handleClick = () => navigate(InspectionResultLink(inspectionResult.id));

  const mobileContent = (
    <Grid container alignItems="center" spacing={1}>
      <Grid size={{ xs: 12 }}>
        <Stack>
          <Typography variant="button">
            <Date date={inspectionResult.doneAt} />
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            <FormattedMessage id="inspection.result.done_by" />: {userLabel(inspectionResult.doneBy)}
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Result result={inspectionResult.result} emptyComponent="-" />
      </Grid>
    </Grid>
  );

  const desktopContent = (
    <Grid container alignItems="center" spacing={2}>
      <Grid size={{ xs: 4 }}>
        <Date date={inspectionResult.doneAt} emptyComponent="-" />
      </Grid>
      <Grid size={{ xs: 4 }} textAlign="center">
        <Result result={inspectionResult.result} emptyComponent="-" />
      </Grid>
      <Grid size={{ xs: 4 }} textAlign="center">
        <Typography variant="body2">{userLabel(inspectionResult.doneBy)}</Typography>
      </Grid>
    </Grid>
  );

  return (
    <IndexListItemButton onClick={handleClick}>
      {isMobile ? mobileContent : desktopContent}
    </IndexListItemButton>
  );
};

export default memo(ListItem);
